/* components/labels/ImportDropdown.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	handle_promise,
	init,
	insert,
	listen,
	mount_component,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import { loadFromRepo } from "~/stores/labels";
import Dropdown from "../Dropdown";

function create_else_block(ctx) {
	let await_block_anchor;
	let promise;

	let info = {
		ctx,
		current: null,
		token: null,
		pending: create_pending_block,
		then: create_then_block,
		catch: create_catch_block,
		error: 10
	};

	handle_promise(promise = /*fetchLabelsPromise*/ ctx[3], info);

	return {
		c() {
			await_block_anchor = empty();
			info.block.c();
		},
		m(target, anchor) {
			insert(target, await_block_anchor, anchor);
			info.block.m(target, info.anchor = anchor);
			info.mount = () => await_block_anchor.parentNode;
			info.anchor = await_block_anchor;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			info.ctx = ctx;

			if (dirty & /*fetchLabelsPromise*/ 8 && promise !== (promise = /*fetchLabelsPromise*/ ctx[3]) && handle_promise(promise, info)) {
				
			} else {
				const child_ctx = ctx.slice();
				info.block.p(child_ctx, dirty);
			}
		},
		d(detaching) {
			if (detaching) detach(await_block_anchor);
			info.block.d(detaching);
			info.token = null;
			info = null;
		}
	};
}

// (54:2) {#if !fetchLabelsPromise}
function create_if_block(ctx) {
	let p;
	let t1;
	let ul;
	let t5;
	let form;
	let input;
	let t6;
	let button;
	let t7;
	let button_disabled_value;
	let dispose;

	return {
		c() {
			p = element("p");
			p.textContent = "Enter repo URL or name and author:";
			t1 = space();
			ul = element("ul");

			ul.innerHTML = `<li>- only works on public repos</li> 
      <li>- will overwrite current labels</li>`;

			t5 = space();
			form = element("form");
			input = element("input");
			t6 = space();
			button = element("button");
			t7 = text("Import");
			attr(p, "class", "f4 mb-1");
			attr(ul, "class", "f5 mb-2");
			attr(input, "class", "form-control border");
			attr(input, "title", /*repoError*/ ctx[2]);
			attr(input, "type", "text");
			attr(input, "placeholder", "IvanFon/super-labeler-action");
			attr(input, "aria-label", "Repository URL or name and author");
			toggle_class(input, "border-red", Boolean(/*repoError*/ ctx[2]));
			button.disabled = button_disabled_value = !/*repoInput*/ ctx[1];
			attr(button, "class", "btn btn-primary btn-sm ml-2");
			attr(button, "type", "submit");
			attr(form, "class", "d-flex");
		},
		m(target, anchor, remount) {
			insert(target, p, anchor);
			insert(target, t1, anchor);
			insert(target, ul, anchor);
			insert(target, t5, anchor);
			insert(target, form, anchor);
			append(form, input);
			set_input_value(input, /*repoInput*/ ctx[1]);
			append(form, t6);
			append(form, button);
			append(button, t7);
			if (remount) run_all(dispose);

			dispose = [
				listen(input, "input", /*input_input_handler*/ ctx[7]),
				listen(input, "input", /*clearError*/ ctx[5]),
				listen(form, "submit", prevent_default(/*handleImport*/ ctx[6]))
			];
		},
		p(ctx, dirty) {
			if (dirty & /*repoError*/ 4) {
				attr(input, "title", /*repoError*/ ctx[2]);
			}

			if (dirty & /*repoInput*/ 2 && input.value !== /*repoInput*/ ctx[1]) {
				set_input_value(input, /*repoInput*/ ctx[1]);
			}

			if (dirty & /*Boolean, repoError*/ 4) {
				toggle_class(input, "border-red", Boolean(/*repoError*/ ctx[2]));
			}

			if (dirty & /*repoInput*/ 2 && button_disabled_value !== (button_disabled_value = !/*repoInput*/ ctx[1])) {
				button.disabled = button_disabled_value;
			}
		},
		d(detaching) {
			if (detaching) detach(p);
			if (detaching) detach(t1);
			if (detaching) detach(ul);
			if (detaching) detach(t5);
			if (detaching) detach(form);
			run_all(dispose);
		}
	};
}

// (97:4) {:catch err}
function create_catch_block(ctx) {
	let p;
	let t0;
	let t1_value = /*err*/ ctx[10].message + "";
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text("Error: ");
			t1 = text(t1_value);
			attr(p, "class", "text-center text-bold text-red");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*fetchLabelsPromise*/ 8 && t1_value !== (t1_value = /*err*/ ctx[10].message + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (86:4) {:then}
function create_then_block(ctx) {
	let div;
	let p;
	let t1;
	let button;
	let dispose;

	return {
		c() {
			div = element("div");
			p = element("p");
			p.textContent = "Success! 🎉";
			t1 = space();
			button = element("button");
			button.textContent = "Close";
			attr(p, "class", "text-center text-bold text-green");
			attr(button, "class", "btn btn-outline btn-sm");
			attr(button, "type", "button");
			attr(div, "class", "d-flex flex-column flex-justify-center");
		},
		m(target, anchor, remount) {
			insert(target, div, anchor);
			append(div, p);
			append(div, t1);
			append(div, button);
			if (remount) dispose();
			dispose = listen(button, "click", /*click_handler*/ ctx[8]);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			dispose();
		}
	};
}

// (82:31)        <p class="text-center text-bold">         Fetching labels<span class="AnimatedEllipsis"></span>       </p>     {:then}
function create_pending_block(ctx) {
	let p;

	return {
		c() {
			p = element("p");

			p.innerHTML = `
        Fetching labels<span class="AnimatedEllipsis"></span>`;

			attr(p, "class", "text-center text-bold");
		},
		m(target, anchor) {
			insert(target, p, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (49:0) <Dropdown   bind:this={dropdown}   on:closed={handleReset}   buttonText="Import from repository" >
function create_default_slot(ctx) {
	let if_block_anchor;

	function select_block_type(ctx, dirty) {
		if (!/*fetchLabelsPromise*/ ctx[3]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let current;

	let dropdown_1_props = {
		buttonText: "Import from repository",
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	const dropdown_1 = new Dropdown({ props: dropdown_1_props });
	/*dropdown_1_binding*/ ctx[9](dropdown_1);
	dropdown_1.$on("closed", /*handleReset*/ ctx[4]);

	return {
		c() {
			create_component(dropdown_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dropdown_1, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const dropdown_1_changes = {};

			if (dirty & /*$$scope, repoInput, repoError, fetchLabelsPromise, dropdown*/ 2063) {
				dropdown_1_changes.$$scope = { dirty, ctx };
			}

			dropdown_1.$set(dropdown_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dropdown_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dropdown_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			/*dropdown_1_binding*/ ctx[9](null);
			destroy_component(dropdown_1, detaching);
		}
	};
}

const nameAuthorRe = /^([a-zA-Z0-9-]+)\/([A-Za-z0-9_.-]+)$/;
const urlRe = /^https?:\/\/github\.com\/([a-zA-Z0-9-]+)\/([A-Za-z0-9_.-]+)$/;

function instance($$self, $$props, $$invalidate) {
	let dropdown;
	let repoInput;
	let repoError;
	let fetchLabelsPromise;

	const handleReset = () => {
		$$invalidate(1, repoInput = "");
		$$invalidate(2, repoError = undefined);
		$$invalidate(3, fetchLabelsPromise = undefined);
	};

	const clearError = () => $$invalidate(2, repoError = undefined);

	const handleImport = async () => {
		let author;
		let name;

		try {
			[,author, name] = repoInput.match(nameAuthorRe);
		} catch {
			try {
				[,author, name] = repoInput.match(urlRe);
			} catch {
				$$invalidate(2, repoError = "Repository not found");
				return;
			}
		}

		const apiUrl = `https://api.github.com/repos/${author}/${name}/labels`;

		$$invalidate(3, fetchLabelsPromise = new Promise(async (resolve, reject) => {
				const res = await fetch(apiUrl);

				if (!res.ok) {
					return reject("Repository not found.");
				}

				const data = await res.json();
				resolve(data);
			}));

		const labels = await fetchLabelsPromise;
		loadFromRepo(labels);
	};

	function input_input_handler() {
		repoInput = this.value;
		$$invalidate(1, repoInput);
	}

	const click_handler = () => dropdown.close();

	function dropdown_1_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(0, dropdown = $$value);
		});
	}

	return [
		dropdown,
		repoInput,
		repoError,
		fetchLabelsPromise,
		handleReset,
		clearError,
		handleImport,
		input_input_handler,
		click_handler,
		dropdown_1_binding
	];
}

class ImportDropdown extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ImportDropdown;